import { IconPropsType } from '..';

export const XIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="42"
    height="42"
    viewBox="0 0 42 42"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21 41C32.0457 41 41 32.0457 41 21C41 9.9543 32.0457 1 21 1C9.9543 1 1 9.9543 1 21C1 32.0457 9.9543 41 21 41Z"
      fill="black"
      stroke="black"
      strokeWidth="0.131277"
      strokeMiterlimit="10"
    />
    <path
      d="M31.0573 30.7229L26.1245 30.6679L12.1504 11.6156H16.7512L31.0573 30.7229Z"
      stroke="white"
      strokeWidth="1.43061"
      strokeMiterlimit="10"
    />
    <path
      d="M22.125 18.7946L29.2838 11H31.0577L22.909 19.8445"
      fill="white"
    />
    <path
      d="M22.125 18.7946L29.2838 11H31.0577L22.909 19.8445"
      stroke="white"
      strokeWidth="0.114448"
      strokeMiterlimit="10"
    />
    <path
      d="M19.5094 21.642L10.5996 31.3385L12.3736 31.2836L20.2819 22.6974"
      fill="white"
    />
    <path
      d="M19.5094 21.642L10.5996 31.3385L12.3736 31.2836L20.2819 22.6974"
      stroke="white"
      strokeWidth="0.114448"
      strokeMiterlimit="10"
    />
  </svg>
);
